import { Pipe, PipeTransform } from '@angular/core';
import { I18NText } from './i18-ntext';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'i18ntexttranslate',
    standalone: false,
})
export class I18ntexttranslatePipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: I18NText[]): string {
        let currLang = this.translate.currentLang;
        let val = value.find((t) => t.langid == currLang);
        if (val) return val.text;
        val = value.find((t) => t.langid == 'en');
        if (val) return val.text;
        if (value.length > 0) return value[0].text;

        return '';
    }
}
